import { useEffect } from 'react';

interface PageMeta {
  title: string;
  description?: string;
  keywords?: string;
}

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export function usePageMeta({ title, description, keywords }: PageMeta) {
  useEffect(() => {
    document.title = title;
    if (description) {
      setMeta('name', 'description', description);
      setMeta('property', 'og:description', description);
      setMeta('name', 'twitter:description', description);
    }
    if (keywords) setMeta('name', 'keywords', keywords);
    setMeta('property', 'og:title', title);
    setMeta('name', 'twitter:title', title);
  }, [title, description, keywords]);
}